import Api from '../utilities/api';
import { triggerIdA } from './apiConfig';
import TriskeleScreens from './TriskeleScreens';

export default class AnalyticsAccess {
    static getReports = clientId => Api.post('_Anlytcs_AnlytcsReports', {
      params: [
        {
          name: 'ScrnId',
          value: TriskeleScreens.dashboard.ScreenId
        },
        {
          name: 'TrggrId',
          value: triggerIdA
        },
        {
          name: 'BuildfireID',
          value: "D"
        },
        {
          name: 'ClientID',
          value: clientId
        },
        {
          name: 'isVisible',
          value: 1
        }
      ]
    });
}
